import html from "./ProjectSearch.html"
import "./ProjectSearch.css"
import moment from 'moment-timezone';

var module = angular.module("ResearchKitApplicationModule");
module.component('projectSearch', {
	template: html,
	bindings: {},
	controller: 'projectSearchController',
	controllerAs: 'vm'
});

module.controller("projectSearchController", ["$scope", "$http", "ceUrl",
	function ($scope, $http, ceUrl) {
		var vm = this;
		var pageNumber = 0;
		vm.reachedEndOfResults = false;

		var searchProjects = _.debounce(function () {
			pageNumber = 0;
			vm.reachedEndOfResults = false;
			vm.results = [];
			fetchProjects(pageNumber, vm.searchString);
		}, 300);

		$scope.$watch("vm.searchString", function () {
			var performSearch = function () {
				vm.results = null;
				vm.reachedEndOfResults = false;
				vm.loading = true;
				searchProjects();
			}

			if (vm.searchString && vm.searchString.length === 6) {
				$http.get(ceUrl.make("api/researchkit/studyenrollment/studies/" + vm.searchString))
					.then(function (response) {
						$scope.$emit("NavigateToView", { type: "ProjectDetail", code: vm.searchString });
					})
					.catch(function (error) {
						performSearch();
					});

			} else {
				performSearch();
			}


		});

		vm.getBrandingImageUrl = function (project) {
			// Aug-23-2021: String interpolation here can break the minifier/bundler.
			return "url('" + ceUrl.make("/api/researchkit/organizationbrandingimage/" + project.OrganizationID) + "')";
		}

		vm.selectProject = function (project) {
			$scope.$emit("NavigateToView", { type: "ProjectDetail", code: project.StudyCode });
		}

		vm.loadMore = function () {
			if (vm.reachedEndOfResults || !vm.results || !vm.results.length) {
				return;
			}

			pageNumber++;
			fetchProjects(pageNumber, vm.searchString);
		}

		var fetchProjects = function (pageNumber, searchString) {
			vm.loading = true;
			var baseUrl = ceUrl.make("api/researchkit/studyenrollment/studies?participantPlatform=Web&includeJoinedAndInvited=false&offset=" + encodeURIComponent(moment().format("Z")));
			if (searchString && searchString.length) {
				baseUrl = baseUrl + "&searchString=" + vm.searchString;
			} else {
				baseUrl = baseUrl + "&searchString=";
			}

			if (pageNumber) {
				baseUrl = baseUrl + "&pageNumber=" + pageNumber;
			}

			$http.get(baseUrl).then(function (response) {
				if (response.data.length == 0) {
					vm.reachedEndOfResults = true;
				}
				vm.results = vm.results.concat(response.data);
			}).finally(function () {
				vm.loading = false;
			});
		}
	}
]);

module.directive('whenVisible', ['$window', function ($window) {
	return function (scope, elm, attr) {
		$window.setInterval(function () {
			var scrollTop = $($window).scrollTop();
			var windowHeight = $($window).height();
			var loaderOffset = elm.offset().top;

			if ((scrollTop + windowHeight) > loaderOffset) {
				scope.$apply(attr.whenVisible);
			}
		}, 300);
	};
}]);
